<template>
  <div>
    <!-- 排序弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="调整列表排序"
      :visible.sync="pxDialogVisible"
      :before-close="pxHandleClose"
      width="37.9%"
      center
    >
      <el-divider></el-divider>
      <div class="pxDialog">
        <el-table
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyleDialog"
          :data="tableData"
          style="width: 100%"
          height="400px"
        >
          <el-table-column  type="index"></el-table-column>
          <el-table-column prop="ProductName"  width="180"></el-table-column>
          <el-table-column  label="操作">
            <template slot-scope="scope">
              <el-button type="text" style="color: #18BDE5;" @click="Topping(scope.row)">置顶</el-button>
              <el-button type="text"  @click="upward(scope.row,index)">前移一位</el-button>
             <!--  <el-button type="text" @click="downward">后移一位</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btn">
        <el-button>恢复</el-button>
        <el-button class="btnL">确认排序</el-button>
      </div>
    </el-dialog>
    <!-- 排序弹框结束 -->
  </div>
</template>

<script>
import  {ProductSort,GetScenicList} from '@/request/scenic.js'
import { Message } from 'element-ui';
export default {
  props:['tableData'],
  data() {
    return {
      pxDialogVisible: false // 排序
    };
  },
  methods: {
    // 置顶
    Topping(row){
      console.log(row)
      let data = {
        token:window.sessionStorage.getItem('Token'),
        SortStaues:2,
        thisid:row.ProductID,
        getid:''
      }
      ProductSort(data).then(res=>{
        console.log(res)
        if(res.data.rcode==200){
          Message.success('置顶成功')
        }else{
          Message.error('置顶失败')
        }
      })
    },
    // 向前
    upward(row,index){
      console.log(row,index)
    },
    // 排序弹框
    pxFn(row) {
      this.pxDialogVisible = true;
    },
    getList(){
      GetScenicList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data.total = res.data.result.total
        }
      })
    },
    // 排序X
    pxHandleClose() {
      this.pxDialogVisible = false;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyleDialog({ row, rowIndex }) {
      return this.utils.cellStyleDialog({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.btn {
    margin: 40px 0 30px 0;
    display: flex;
    justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
  .btnL {
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.pxDialog {
  /deep/.el-table__header-wrapper {
    display: none;
  }
}
/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
}
/deep/ .ant-message{
  z-index: 9999;
}
</style>